import { DocumentFormProps } from '@/Domains/Document/UI/DocumentForm/DocumentForm';
import { useContact, useProperty } from '@/OneLiners';
import { FaBuilding, FaUser, Form, Formik, FormikProps, OptionHelper, SelectField, SubmitButton, useAppEnum } from '@/Shared';
import React, { FC } from 'react';

const ViewingAcknowledgmentForm: FC<DocumentFormProps> = ({
	document,
	handleClose,
	handleCancel,
	id
}) => {

	const contactHook = useContact();
	const propertyHook = useProperty();

	const contactOptions = OptionHelper.contactOptions(contactHook.dataMap.toArray());

	const { PropertyEnums } = useAppEnum();
	const propertyOptions = OptionHelper.propertyOptions(
		propertyHook.dataMap.toArray(),
		PropertyEnums.PropertyTypeEnum
	);

	const handleSubmit = (values: Record<string, any>) => {
		handleClose();
		const payload = {
			...values,
			propertyIds: values.propertyIds.map(Number),
		};
		document.handler(payload);
	}

	return (
		<div className="fade-in" data-testid="GenericDomainForm">
			{/* Formik wrapper for handling form state and validation */}
			<Formik<any>
				initialValues={{
					id: id,
					propertyIds: []
				}}
				enableReinitialize={true}
				onSubmit={handleSubmit}
			>

				{(formikProps: FormikProps<any>) =>
					<Form className='form-in-modal'>
						<fieldset>
							<legend>Informations générales</legend>
						<SelectField
							label='Contact'
							icon={<FaUser />}
							name='id'
							placeholder='Choisir un contact'
							options={contactOptions}
							required
						/>

						<SelectField
							label='Biens à visiter'
							icon={<FaBuilding />}
							name='propertyIds'
							options={propertyOptions}
							isMulti
						/>
						
						</fieldset>
						{/* Submit button reflecting form validity and loading state */}
						<SubmitButton
							disabled={!formikProps.dirty || !formikProps.isValid}
							label='Générer'
						/>
					</Form>
				}
			</Formik >
		</div>
	);
}

export default ViewingAcknowledgmentForm;